import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 5l3 3l-3 3","key":"svg-0"}],["path",{"d":"M3 18h5l7 -10h6","key":"svg-1"}]]

/**
 * IconTrendingUp2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdHJlbmRpbmctdXAtMiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTggNWwzIDNsLTMgMyIgLz4KICA8cGF0aCBkPSJNMyAxOGg1bDcgLTEwaDYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/trending-up-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTrendingUp2 = createReactComponent('outline', 'trending-up-2', 'TrendingUp2', __iconNode);

export default IconTrendingUp2;